
    import { Component, Vue } from 'vue-property-decorator';
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import Beleg from '@/types/Beleg';
    import { DataTableHeaders } from '@/types';

    @Component({
        computed: {
            ...mapState('patient', ['rechnungen']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapMutations('patient', ['setSelectedRechnung', 'setDruckansicht']),
        },
    })
    export default class RechnungenDatatable extends Vue {
        public rechnungen!: Beleg[];
        public setSelectedRechnung!: (beleg: Beleg) => void;
        public setDruckansicht!: (visible: boolean) => void;

        public get headers(): DataTableHeaders<Beleg, 'actions' | 'jahr_belegnr'> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Beleg Nr.', value: 'jahr_belegnr', sortable: false },
                { text: 'Datum', value: 'datum' },
                { text: 'Betrag', value: 'gesamtbetrag' },
                { text: 'Anmerkung', value: 'anmerkung' },
                { text: 'Zahlungsart', value: 'zahlungsart' },
            ];
        }

        public onClickRechnung(beleg: Beleg): void {
            this.setSelectedRechnung(beleg);
            this.setDruckansicht(true);
        }
    }
